var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5323 69.6964L53.9863 53.1504L54.0563 172.75L54.2543 178.34C54.3363 180.97 54.8243 183.938 55.6383 187.014L186.742 233.244L219.514 218.724L219.526 218.684L70.5323 69.6964Z",
    fill: "#00D2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6393 187.015L55.6473 187.023C55.6393 186.969 55.6113 186.909 55.6113 186.853C55.6113 186.909 55.6193 186.961 55.6393 187.015ZM219.515 218.725L186.743 233.245L55.6473 187.023C58.1513 196.631 63.6953 207.431 69.6613 213.337L112.445 255.877L207.575 256.001L219.527 218.685L219.515 218.725Z",
    fill: "#55DDCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03318 130.116C-1.20282 134.638 0.901184 143.966 7.72118 150.838L37.1392 180.5L55.6392 187.014C54.8252 183.938 54.3372 180.97 54.2552 178.34L54.0572 172.75L53.9872 53.1504L3.03318 130.116Z",
    fill: "#0081C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.818 54.686C184.742 53.9 181.792 53.414 179.118 53.33L173.21 53.126L53.9863 53.142L219.542 218.684H219.556L234.096 185.88L187.818 54.686Z",
    fill: "#0079B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.67 54.6543C187.734 54.6683 187.784 54.6863 187.826 54.6923L187.82 54.6863C187.784 54.6683 187.734 54.6683 187.67 54.6543ZM214.118 68.7323C208.11 62.6743 197.452 57.1683 187.826 54.6923L234.098 185.88L219.558 218.684H219.544L255.076 207.336L255.152 109.92L214.118 68.7323Z",
    fill: "#00A4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.336 36.2981L151.682 6.86206C144.824 0.0680599 135.492 -2.04594 130.982 2.17806L53.9863 53.1421L173.21 53.1261L179.118 53.3301C181.792 53.4141 184.742 53.9001 187.818 54.6861L181.336 36.2981Z",
    fill: "#00D2B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.30bf58d853422517dd7fec5c2cae50b6.svg";
export { ForwardRef as ReactComponent };